import graphql from "babel-plugin-relay/macro";

const PortfolioUserPerformanceQuery = graphql`
query PortfolioUserPerformanceQuery($weeks:Int,$month:Int,$days:Int,$all:Boolean){
    userPerformanceAnalysis(weeks:$weeks,month:$month,days:$days,all:$all){
        marketCurrentTotal
        created
    }
}
`

export default PortfolioUserPerformanceQuery
